import { toast } from 'react-toastify';

/**
 * Extrae mensaje de error del response
 */
const getErrorMessage = (error, defaultMessage) => {
    // Error de red
    if (error.code === 'ERR_NETWORK' || !error.response) {
        return 'Error de conexión. Por favor, verifica tu conexión a internet.';
    }

    // Timeout
    if (error.code === 'ECONNABORTED') {
        return 'La solicitud tardó demasiado. Por favor, inténtalo de nuevo.';
    }

    // Mensaje del servidor
    const serverMessage = error.response?.data?.error ||
        error.response?.data?.message ||
        error.response?.data?.detail;

    if (serverMessage) {
        return serverMessage;
    }

    // Mensajes por código de estado
    const status = error.response?.status;
    switch (status) {
        case 400:
            return 'Datos inválidos. Por favor, revisa la información.';
        case 401:
            return 'No autorizado. Por favor, inicia sesión nuevamente.';
        case 403:
            return 'No tienes permisos para realizar esta acción.';
        case 404:
            return 'Recurso no encontrado.';
        case 500:
            return 'Error del servidor. Por favor, inténtalo más tarde.';
        default:
            return defaultMessage;
    }
};

/**
 * Notificación de éxito
 */
export const notifySuccess = (message, options = {}) => {
    toast.success(message, {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 3000,
        ...options,
    });
};

/**
 * Notificación de error
 */
export const notifyError = (error, defaultMessage = 'Ha ocurrido un error', options = {}) => {
    const message = typeof error === 'string'
        ? error
        : getErrorMessage(error, defaultMessage);

    toast.error(message, {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 5000,
        ...options,
    });
};

/**
 * Notificación de advertencia
 */
export const notifyWarning = (message, options = {}) => {
    toast.warning(message, {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 4000,
        ...options,
    });
};

/**
 * Notificación informativa
 */
export const notifyInfo = (message, options = {}) => {
    toast.info(message, {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 3000,
        ...options,
    });
};

/**
 * Notificación con promesa (para operaciones async)
 */
export const notifyPromise = (promise, messages) => {
    return toast.promise(
        promise,
        {
            pending: messages.pending || 'Procesando...',
            success: messages.success || 'Operación completada',
            error: {
                render({ data }) {
                    return getErrorMessage(data, messages.error || 'Error en la operación');
                }
            }
        },
        {
            position: toast.POSITION.BOTTOM_RIGHT,
        }
    );
};

const notifications = {
    success: notifySuccess,
    error: notifyError,
    warning: notifyWarning,
    info: notifyInfo,
    promise: notifyPromise,
};

export default notifications;
